module.exports = __webpack_public_path__ + "img/icon-horizontal-line-white.bfdd0ceb.svg";